<template>
	<div class="row mt-4">
		<div class="col-12 col-md-4 mb-3">
			<OpenDataAddress v-on:address-found="address_found" v-on:typed-address="typed_address"></OpenDataAddress>
			<div class="row mt-4">
				<div class="form-group col-12 col-md-9">
					<label for="address-lookup-radius">{{ $t('radius') }}</label>
					<input type="text" class="form-control" id="address-lookup-radius" v-model="radius">
					<small class="form-text text-muted">
						{{ $t('radius-explanation') }}
					</small>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-8">
			<GmapMap :center="centre" :zoom="zoom" style="width: 100%; height: 600px" ref="map" class="box">
				<GmapMarker
					v-if="marker"
					:position="centre"
				></GmapMarker>
				<GmapCircle
					v-if="marker && radius"
					:center="centre"
					:radius="parseFloat(radius)"
				></GmapCircle>
			</GmapMap>
		</div>
	</div>
</template>

<script>
const WINNIPEG_CENTRE = {lat: 49.86, lng: -97.158465};

import OpenDataAddress from '@/components/OpenDataAddress';
import {gmapApi} from 'vue2-google-maps'

	export default {
		props: ['location'],
		components: { OpenDataAddress },
		data() {
			return {
				polygon_default_options: {
					strokeOpacity: 0.5,
					strokeWeight: 1,
					fillOpacity: 0.2,
					fillColor: 'black',
				},
				address: this.location,
				radius: 500,
			}
		},
		watch: {
			location() {
				this.address = this.address;
			},
			radius() {
				this.update_parent();
			}
		},

		computed: {
			centre() {
				if (this.marker) {
					return { lat: parseFloat(this.address.location.latitude), lng: parseFloat(this.address.location.longitude) };
				}
				return WINNIPEG_CENTRE;
			},

			zoom() {
				if (this.address && this.address.location) {
					return 15;
				}

				return 11;
			},

			marker() {
				return (this.address && this.address.location);
			}
		},

		methods: {
			update_parent() {
				this.$emit('choose',{address: this.address,radius: this.radius});
			},

			address_found(address) {
				this.address = address;
				this.update_parent();
			},

			typed_address(typed) {
				this.address = null;
				if (typed === '') {
					this.$emit('clear');
				}
			}
		}
	}
</script>
